import useSWR from "swr";

export const useFetchRestaurantAccessToken = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `external_api/line-access-token/?restaurantId=${restaurantId}` : null;
  const { data: accessToken, error, isLoading } = useSWR<string>(fetcherKey);
  return { accessToken, isLoading, error };
};